export const CLOSE_RIGHT_DRAWER = "closeRightDrawer";
export const DISMISS_TOASTER_MESSAGE = "dismissToasterMessage";
export const SET_TOASTER_MESSAGE = "setToasterMessage";
export const TOGGLE_LEFT_DRAWER = "toggleLeftDrawer";
export const TOGGLE_RIGHT_DRAWER = "toggleRightDrawer";
